import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';
import { isNotNull } from '../../common/util.services';
import { getCurrencyByName, saveCurrency } from '../currency.services';
import './currency-form.component.scss';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';

const CurrencyForm = (props: any) => {
  const [title, setTitle] = useState<string>('Add Currency');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const currency = params.currency;
  const [currencyData, setCurrencyData] = useState<any>({});

  useEffect(() => {
    if (isNotNull(currency)) {
      getCurrencyByName(currency, appContext,
        (response: any) => {
          setTitle('Edit Currency');
          setCurrencyData(response.data);
          appContext.setSuccessMessage(response.message);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
        });
    }
  }, []);

  const onSubmit = (data: any) => {
    saveCurrency(data, appContext,
      (response: any) => {
        navigate('/currency/list');
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  const getMainComponent = () => {
    return <Grid container spacing={1} alignItems={'center'}>
      <Grid xs={4}>
        <ITextField name='currency' label='Currency' required={true} />
      </Grid>
      <Grid xs={4}>
        <INumberField name='rate' label='Rate' required={true} />
      </Grid>
      <Grid xs={4}>
        <INumberField name='contingency' label='Contingency (%)' required={true} />
      </Grid>
    </Grid>
  }

  return appContext.showLoader ? <></> : <IForm formData={currencyData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default CurrencyForm;